export default "__VITE_ASSET__DEM3NV2a__"